<i class="fas fa-comment-alt"></i>
<span *ngIf="identifier" class="spot-im-replies-count" [attr.data-post-id]="identifier"></span>